import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.div`
	font-size: ${helpers.font.size.baseSmall};
`
